import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import ROUTES from '../../routers/routes'
import { validateRole } from '../../utils/RoutesHelper'

const ProtectedRoute = ({ isAuthenticated, userRoles, ...props }) => {
  const { roles } = props
  return validateRole(roles, userRoles) ? (
    <Route {...props} />
  ) : (
    <Redirect to={ROUTES.HOME.pathname} />
  )
}

ProtectedRoute.propTypes = {
  isAuthenticated: PropTypes.bool,
  userRoles: PropTypes.arrayOf(PropTypes.string),
  roles: PropTypes.arrayOf(PropTypes.string),
}

export default ProtectedRoute
